"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableColumnChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var PluggableColumnBarCharts_1 = require("../PluggableColumnBarCharts");
var axis_1 = require("../../../constants/axis");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PluggableColumnChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableColumnChart, _super);
    function PluggableColumnChart(props) {
        var _this = _super.call(this, props) || this;
        _this.secondaryAxis = axis_1.AXIS_NAME.SECONDARY_Y;
        _this.type = sdk_ui_1.VisualizationTypes.COLUMN;
        _this.defaultControlsProperties = {
            stackMeasures: false,
        };
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableColumnChart.prototype.getSupportedPropertiesList = function () {
        return supportedProperties_1.COLUMN_CHART_SUPPORTED_PROPERTIES[this.axis || axis_1.AXIS.DUAL] || [];
    };
    return PluggableColumnChart;
}(PluggableColumnBarCharts_1.PluggableColumnBarCharts));
exports.PluggableColumnChart = PluggableColumnChart;
//# sourceMappingURL=PluggableColumnChart.js.map